import { ActionRuleParams } from '../../types';
import { formatValidation, getIslandLetter } from '../island-validation-format';
import { getSurroundFinishProfile, type FinishFamilyKey } from '../../../../helpers';
import { libLang } from '../../../../lang'
import { NotificationType } from '../../../notifications/enums';

// Documented overhang ceilings per finish family: MOK's hard cap is 8" (moks-playbook), everyone else is the 10" seating standard (guide-2026).
const MAX_OVERHANG_BY_FAMILY: Record<FinishFamilyKey, number> = {
	standard: 10,
	mok: 8,
	slat: 10
};

export const overhangLimit = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { islands } = refMap
	const { notifications } = refMap.kitchen.design

	notifications.purgeReferences(libLang.validations.island.panel.overhang);

	if (!islands || !islands.children) return

	islands.children.forEach((island) => {
		const maxOverhang = MAX_OVERHANG_BY_FAMILY[getSurroundFinishProfile(island.surround?.material)?.key ?? 'standard'];

		island.panels.children.forEach((panel) => {
			if (panel.countertopOverhang > maxOverhang) {
				notifications.add({
					refId: panel.id,
					validationCode: libLang.validations.island.panel.overhang,
					description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, location: panel.label, issue: `Overhang exceeds the allowed limit of ${maxOverhang} inches` }),
					type: NotificationType.Warn
				})
			}
		})
	})
}
